<template>
  <div id="app">
    <div class="border d-block d-md-block d-lg-block">
      <div class="row mx-4 mb-5">
        <div class="col-md-12 col-lg-4">
          <!-- <div class="mb-4" style="text-align: left">Cena</div>
          <vue-range-slider
            ref="slider"
            width="100%"
            v-model="price"
            @input="filterdTable(price, area, isAvailable)"
            :min="minPrice"
            :max="maxPrice"
            :step="10000"
          >
          </vue-range-slider>
        </div> -->
          <div
            class="mb-5 mt-2"
            style="text-align: center; padding-bottom: 2.5rem"
          >
            Pokoje
          </div>
          <vue-range-slider
            ref="slider"
            width="100%"
            v-model="rooms"
            @input="filterdTable(rooms, area, isAvailable)"
            :min="minRooms"
            :max="maxRooms"
            :step="1"
          >
          </vue-range-slider>
        </div>
        <div class="col-md-12 col-lg-4">
          <div
            class="mb-5 mt-2"
            style="text-align: center; padding-bottom: 2.5rem"
          >
            Powierzchnia
          </div>
          <vue-range-slider
            ref="slider"
            width="100%"
            v-model="area"
            @input="filterdTable(rooms, area, isAvailable)"
            :min="minArea"
            :max="maxArea"
            :step="5"
          >
          </vue-range-slider>
        </div>

        <div class="col-md-12 col-lg-4">
          <div class="mb-5" style="text-align: center; padding-bottom: 2.5rem">
            Tylko dostępne
          </div>
          <input
            type="checkbox"
            v-model="isAvailable"
            @change="filterdTable(rooms, area, isAvailable)"
          />
        </div>
      </div>

      <div class="row" style="max-width: 98%">
        <table
          class="
            twoqbsxml-table
            table table-striped
            d-none d-md-table d-lg-table
            mx-4
            my-4
          "
        >
          <thead class="twoqbsxml-thead">
            <th scope="col" class="twoqbsxml-th">BUDYNEK</th>
            <th scope="col" class="twoqbsxml-th">KONDYGNACJA</th>
            <th scope="col" class="twoqbsxml-th">NR LOKALU</th>
            <th scope="col" class="twoqbsxml-th">POWIERZCHNIA</th>
             <th scope="col" class="twoqbsxml-th">TARAS</th>
            <!-- <th scope="col" class="twoqbsxml-th">BALKON</th> -->
            <th scope="col" class="twoqbsxml-th">OGRÓD</th> 
            <th scope="col" class="twoqbsxml-th">POKOJE</th>
            <th scope="col" class="twoqbsxml-th">STATUS</th>
            <th scope="col" class="twoqbsxml-th">PLAN LOKALU</th>
            <!-- <th scope="col" class="twoqbsxml-th">PLAN OGRÓDKA</th> -->
            <th scope="col" class="twoqbsxml-th">WIDOK 3D</th> 
            <th scope="col" class="twoqbsxml-th">CENA</th>
          </thead>
          <tbody>
            <tr class="twoqbsxml-tr" v-for="item in tableFlats" :key="item.id">
              <td class="twoqbsxml-td twoqbsxml-local-name">
                <span v-if="item.building.length != 0">{{ item.building }}</span
                ><span v-else>-</span>
              </td>
              <td class="twoqbsxml-td twoqbsxml-local-name">
                {{ item.floor}}
              </td>
              <td class="twoqbsxml-td twoqbsxml-local-name">
                {{ item.local_number }}
              </td>
              <td class="twoqbsxml-td">
                {{ item.area }}<var>m<sup>2</sup></var>
              </td>
             <td class="twoqbsxml-td">
                <span v-if="item.taras"
                  >{{ item.taras }}<var>m<sup>2</sup></var></span
                ><span v-else>-</span>
              </td>
              <!--
              <td class="twoqbsxml-td">
                <span v-if="item.balkon"
                  >{{ item.balkon }}<var>m<sup>2</sup></var></span
                ><span v-else>-</span>
              </td> -->
              <td class="twoqbsxml-td">
                <span v-if="item.ogrod"
                  >{{ item.ogrod }}<var>m<sup>2</sup></var></span
                ><span v-else>-</span>
              </td> 
              <td class="twoqbsxml-td">
                <span v-if="item.rooms.length != 0">{{ item.rooms }}</span
                ><span v-else>-</span>
              </td>
              <td class="twoqbsxml-td">
                <span v-if="item.status_name == 'Dostępne'">{{
                  item.status_name
                }}</span>
                 <span v-if="item.promotion == 1 && item.status_name == 'Dostępne' " style="font-weight:900; color:green">Promocja</span>
                <span
                  v-if="
                    item.status_name == 'Rezerwacja ustna' ||
                    item.status_name == 'Wstrzymane'
                  "
                  style="color: orange"
                  >Rezerwacja</span
                >
               
                <span
                  v-if="
                    item.status_name == 'Umowa rezerwacyjna' ||
                    item.status_name == 'Umowa deweloperska' ||
                    item.status_name == 'Umowa przedwstępna' ||
                    item.status_name == 'Sprzedany'
                  "
                  
                  style="color: red"
                  >Sprzedany</span
                >

              </td>
              <td class="twoqbsxml-td twoqbsxml-download-element">
                <a
                  style="text-decoration: none; color: black"
                  v-bind:href="item.document_link"
                  target="_blank"
                  >POBIERZ</a
                >
              </td>
             <td class="twoqbsxml-td twoqbsxml-download-element">
                <a
                  style="text-decoration: none; color: black"
                  v-bind:href="item.plan3d_link[0]"
                  target="_blank"
                  >POBIERZ</a
                > </td>
             <!-- </td> <td class="twoqbsxml-td twoqbsxml-download-element">
                <a
                  style="text-decoration: none; color: black"
                  v-bind:href="item.plan_preview"
                  target="_blank"
                  >ZOBACZ</a
                >
              </td> -->
              <td class="twoqbsxml-td twoqbsxml-ask">
                <span class="ask-button" @click="showModal(item)" v-if="item.ask_for_price == 1"> Zapytaj</span>
                <p @click="showModal(item)" v-if="item.price && item.ask_for_price != 1 && (item.status_name!='Wstrzymane' && item.status_name != 'Rezerwacja ustna')" >{{ numberWithSpaces(item.price) }} zł</p>
                <!-- <span @click="showModal(item)" v-if="item.price && item.ask_for_price != 1 && item.promotion == 0 && (item.status_name!='Wstrzymane' && item.status_name != 'Rezerwacja ustna')" >{{ numberWithSpaces(item.price) }} zł</span>
                <span class="td-promotion-price" @click="showModal(item)" v-if="item.price && item.ask_for_price != 1 && item.promotion == 1">{{ numberWithSpaces(item.promotion_price) }} zł</span> -->
                <span v-if="(!item.price || item.status_name=='Wstrzymane' || item.status_name == 'Rezerwacja ustna')  && item.ask_for_price != 1">-</span>
                <span v-if="(
                              item.status_name == 'Umowa rezerwacyjna' ||
                              item.status_name == 'Umowa deweloperska' ||
                              item.status_name == 'Umowa przedwstępna' ||
                              item.status_name == 'Wstrzymane' || 
                              item.status_name == 'Rezerwacja ustna')"></span>
              </td>
            </tr>
          </tbody>
        </table>
        <div
          class="d-block d-sm-block d-md-none mx-4 p-2 border"
          style="text-align: left"
          v-for="item in tableFlats"
          :key="item.id"
        >
        <p class="twoqbsxml-p"><b>Budynek:</b> <span v-if="item.building.length != 0">{{ item.building }}</span
                ><span v-else>-</span></p>
        <p class="twoqbsxml-p"><b>Kondygnacja:</b> {{ item.floor }}</p>
          <p class="twoqbsxml-p"><b>Numer:</b> {{ item.local_number }}</p>
          <p class="twoqbsxml-p">
            <b>Powierzchnia:</b> {{ item.area }}<var>m<sup>2</sup></var>
          </p>
         <p class="twoqbsxml-p">
            <b>Taras:</b
            ><span v-if="item.taras"
              >{{ item.taras }}<var>m<sup>2</sup></var></span
            ><span v-else>-</span>
          </p>

        <!--
          <p class="twoqbsxml-p">
            <b>Balkon:</b
            ><span v-if="item.balkon"
              >{{ item.balkon }}<var>m<sup>2</sup></var></span
            ><span v-else>-</span>
          </p> -->
          <p class="twoqbsxml-p">
            <b>Ogród:</b> {{ item.ogrod }}<var>m<sup>2</sup></var>
          </p>
          <p class="twoqbsxml-p"><b>Pokoje:</b> <span v-if="item.rooms.length != 0">{{ item.rooms }}</span
                ><span v-else>-</span></p>
          <p class="twoqbsxml-p">
            <b>Status:</b>
            <span v-if="item.status_name == 'Dostępne'">{{
              item.status_name
            }}</span>
             <span v-if="item.promotion == 1 && item.status_name == 'Dostępne' " style="font-weight:900; color:green">Promocja</span>
            <span
              v-if="
                item.status_name == 'Rezerwacja ustna' ||
                item.status_name == 'Wstrzymane'
              "
              style="color: orange"
              >Rezerwacja</span
            >
            <span
              v-if="
                item.status_name == 'Umowa rezerwacyjna' ||
                item.status_name == 'Umowa deweloperska' ||
                item.status_name == 'Umowa przedwstępna' || 
                item.status_name == 'Sprzedany'
              "
              style="color: red"
              >Sprzedany</span
            >
          </p>
          <p class="twoqbsxml-p">
            <b>Plan Lokalu: </b>
            <a class="twoxbsxml-download-element" v-bind:href="item.document_link" target="_blank">POBIERZ</a>
          </p>
          <!-- <p class="twoqbsxml-p">
            <b>Plan Ogródka: </b>
            <a class="twoxbsxml-download-element" v-bind:href="item.card_link[2]" target="_blank">POBIERZ</a>
          </p>
        -->
          <p class="twoqbsxml-p">
            <b>Widok 3D: </b>
            <a class="twoxbsxml-download-element" v-bind:href="item.plan3d_link[0]" target="_blank">POBIERZ</a>
          </p>
          <p class="twoqbsxml-p twoqbsxml-ask-element">
            <b>Cena: </b>
            <span class="ask-button" @click="showModal(item)" v-if="item.ask_for_price == 1"> Zapytaj</span>
            <span @click="showModal(item)" v-if="item.price > 1 && item.ask_for_price != 1 && (item.status_name!='Wstrzymane' && item.status_name != 'Rezerwacja ustna')" >{{ numberWithSpaces(item.price) }} zł</span>
                <!-- <span @click="showModal(item)" v-if="item.price && item.ask_for_price != 1 && item.promotion == 0 && (item.status_name!='Wstrzymane' && item.status_name != 'Rezerwacja ustna')" >{{ numberWithSpaces(item.price) }} zł</span>
                <span class="td-promotion-price" @click="showModal(item)" v-if="item.price && item.ask_for_price != 1 && item.promotion == 1">{{ numberWithSpaces(item.promotion_price) }} zł</span> -->
                <span v-if="(!item.price || item.status_name=='Wstrzymane' || item.status_name == 'Rezerwacja ustna') && item.ask_for_price != 1">-</span>
                <span v-if="(
                              item.status_name == 'Umowa rezerwacyjna' ||
                              item.status_name == 'Umowa deweloperska' ||
                              item.status_name == 'Umowa przedwstępna' ||
                              item.status_name == 'Wstrzymane' || 
                              item.status_name == 'Rezerwacja ustna')"></span>
               
               
          </p>
        </div>
      </div>
    </div>
    <contact-form :flat="flat"></contact-form>
  </div>
</template>

<script>
import axios from "axios";
import "vue-range-component/dist/vue-range-slider.css";
import VueRangeSlider from "vue-range-component";

import ContactForm from "./components/ContactForm";

export default {
  name: "App",
  data() {
    return {
      dataUrl: "https://willa-wroclaw.pl/wp-json/twoqbs/v1/flats",
      tableFlats: [],
      flats: [],
      //--Filtrowanie.
      minPrice: 900000,
      maxPrice: 1600000,
      price: [900000, 1600000],
      //--
      minArea: 90,
      maxArea: 160,
      area: [90, 160],
      //---
      minRooms: 0,
      maxRooms: 5,
      rooms: [0, 5],
      isAvailable: false,
      flat: "",
    };
  },
  components: {
    VueRangeSlider,
    "contact-form": ContactForm,
  },
  methods: {
    numberWithSpaces(price) {
    console.log(price)
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ").slice(0,-3);
},
    test() {
      console.log(this.isAvailable);
    },

    compare(a, b) {
              if (a.local_number < b.local_number) return -1;
              if (a.local_number > b.local_number) return 1;
              return 0;
            },

    filterdTable(rooms, area, available) {
      this.tableFlats = [];
      console.log(available)
      console.log(rooms)
      console.log(area)
      this.flats.realestate.forEach((item) => {
        console.log(item.card_link[(item.card_link.length)-1])
        if (available) {
          if (
            item.rooms >= rooms[0] &&
            item.rooms <= rooms[1] &&
            item.area >= area[0] &&
            item.area <= area[1] &&
            item.status_name === "Dostępne"
          ) {
            if(item.dont_send_to_www == 0){
              this.tableFlats.push(item);
              this.tableFlats.sort(this.compare);
            }
          }
        }

        if (!available) {
          if (
            item.rooms >= rooms[0] &&
            item.rooms <= rooms[1] &&
            item.area >= area[0] &&
            item.area <= area[1]
          ) {
  
            if(item.dont_send_to_www == 0 && item.status_id != 9){
              this.tableFlats.push(item);
              this.tableFlats.sort(this.compare);
            }
          }
        }
      });
    },
    showModal(flatName) {
      console.log(flatName);
      this.$modal.show("contact-form");
      this.flat = flatName.local_number;
    },
  },

  mounted() {
    axios.get(this.dataUrl).then((response) => {
      this.flats = response.data;
      this.tableFlats = this.flats.realestate;
      this.tableFlats.sort(this.compare);
      this.filterdTable(this.rooms, this.area, this.available) 
    });
    axios.post(this.restUrl, this.contactForm).then((response) => {
      console.log(response);
    });
  },
};
</script>

<style>
#app {
  font-family: "Encode Sans", Sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  display: block;
  
}
.simple-range-slider {
  bottom: -30px;
  background: none;
  box-shadow: none;
}
.modal {
  position: absolute;
  width: 500px;
  height: 500px;
  background-color: red;
}
@import "./assets/vue-range-slider.css";
@import "./assets/bootstrap.min.css";
</style>
